import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgUp({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.851 5.01l.067-.007.101-.003.07.004.112.016.111.03.111.043.098.053.096.067c.031.024.062.051.09.08l6 6a1 1 0 01-1.32 1.497l-.094-.083L13 8.413V18a1 1 0 01-.883.993L12 19a1 1 0 01-.993-.884L11 18V8.414l-4.293 4.293a1 1 0 01-1.32.083l-.094-.083a1 1 0 01-.083-1.32l.083-.094 6-6 .046-.044.066-.053.11-.072.114-.053.105-.035.117-.025z"
        fill={color}
      />
    </svg>
  )
}

export default SvgUp
